import React, { useState, useEffect } from 'react';
import StudentDocumentManager from './StudentDocumentManager';
import QuizView from './QuizView';
import '../styles/StudentNotesWorkflow.scss';
import { track } from '@vercel/analytics';

function StudentNotesWorkflow({
  API_BASE_URL,
  authToken,
  userData,
  onBack
}) {
  const [workflowStep, setWorkflowStep] = useState('documents'); // documents -> quiz
  const [quizId, setQuizId] = useState(null);
  const [attemptId, setAttemptId] = useState(null);
  
  useEffect(() => {
    // Track entry into student notes workflow
    track('student_notes_workflow_entered', {
      user_role: userData?.role || 'unknown'
    });
  }, [userData?.role]);

  // Handle quiz creation completion
  const handleQuizCreated = (createdQuizId) => {
    setQuizId(createdQuizId);
    setWorkflowStep('quiz');
    track('student_notes_quiz_created', {
      quiz_id: createdQuizId,
      user_role: userData?.role || 'unknown'
    });
  };

  // Handle quiz completion
  const handleQuizComplete = () => {
    // Reset to document management
    setQuizId(null);
    setAttemptId(null);
    setWorkflowStep('documents');
    track('student_notes_quiz_completed', {
      user_role: userData?.role || 'unknown'
    });
  };

  // Handle back navigation
  const handleBack = () => {
    if (workflowStep === 'quiz') {
      setWorkflowStep('documents');
      setQuizId(null);
      setAttemptId(null);
    } else {
      onBack(); // Go back to main subject selection
    }
  };

  return (
    <div className="student-notes-workflow">
      {workflowStep === 'documents' && (
        <StudentDocumentManager
          API_BASE_URL={API_BASE_URL}
          authToken={authToken}
          userData={userData}
          onBack={onBack}
          onQuizCreated={handleQuizCreated}
        />
      )}
      
      {workflowStep === 'quiz' && quizId && (
        <QuizView
          API_BASE_URL={API_BASE_URL}
          authToken={authToken}
          userData={userData}
          quizId={quizId}
          attemptId={attemptId}
          onBack={handleBack}
          onComplete={handleQuizComplete}
          isCustomQuiz={true}
        />
      )}
    </div>
  );
}

export default StudentNotesWorkflow; 